import { useRouter } from "@tanstack/react-router";

import { Button } from "@/components/ui/button/button";
import { BwNotFound } from "@/components/ui/icons";
import { Separator } from "@/components/ui/separator";

export default function NotFound() {
  const router = useRouter();

  const handleBackHomePage = () => {
    router.history.replace("/");
  };

  const handleBackPreviousPage = () => {
    router.history.back();
  };

  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-90 grow">
      <div className="flex flex-col items-center justify-center mt-12 text-center">
        <BwNotFound size={96} />

        <h1 className="pt-6 pb-2 text-3xl font-semibold text-text-dark">
          Page not found
        </h1>
        <div className="block mt-2 mb-0 text-base font-normal text-text-dark-high">
          The page you're looking for can't be found.
        </div>
        <Separator className="my-2" />
        <div className="block text-xs font-semibold text-text-dark-high">
          Error code: 404
        </div>
        <div className="mt-2 mb-0 text-sm font-normal text-text-dark-high">
          Someone may have deleted it, changed its name, <br />
          or it's temporarily unavailable. Try checking the address or go to:
        </div>
      </div>
      <div className="flex flex-col items-center justify-center mt-8 space-y-2">
        <Button className="w-full sm:w-90" onClick={handleBackPreviousPage}>
          Go to the previous page
        </Button>
        <Button
          kind="outline"
          variant="neutral"
          className="w-full sm:w-90"
          onClick={handleBackHomePage}
        >
          Go to home
        </Button>
      </div>
    </div>
  );
}
